import React from "react";

import { lightTeal, white } from "./base/colors";
import Flex from "./base/flex";
import Link from "./base/link";

import Section from "./section";

import { useContentContext } from "../context/content-context";
import { useISIContext } from "../context/isi-context";

import ThemedPageWrapper from "./themed-page-wrapper";
import Heading from "../components/base/heading";
import { lightBlue } from "../components/base/colors";

const IsiButton = ({ variant }) => {
  const { ISIScrollButton } = useISIContext();
  const { language } = useContentContext();

  return (
    <ISIScrollButton>
      <Link
        as="div"
        variant={variant}
        style={{
          textTransform: "none",
          cursor: "pointer",
          textAlign: "left",
        }}
      >
        {language === "esp"
          ? "Información importante de seguridad"
          : "Important Safety Information"}
      </Link>
    </ISIScrollButton>
  );
};
const Sitemap = () => {
  const { sitemapMenuItems, secondaryMenuItems, isHCP } = useContentContext();
  const variant = isHCP ? "hcpSitemap" : "patientSitemap";

  return (
    <ThemedPageWrapper>
      {isHCP && (
        <Section>
          <Heading fontSize="45px" color={lightBlue} level="h1">
            Sitemap
          </Heading>
        </Section>
      )}

      <Section
        flexDirection="column"
        backgroundColor={isHCP ? white : lightTeal}
      >
        <Flex flexDirection="column" mb="60px">
          {sitemapMenuItems.map(({ title, attr_title, url }) => (
            <Link key={url} href={url} variant={variant}>
              {attr_title || title}
            </Link>
          ))}
        </Flex>

        <Flex flexDirection="column">
          <IsiButton variant={variant} />
          {secondaryMenuItems.map(({ post_title, attr_title, url }) => (
            <Link
              href={url}
              key={url}
              target="_blank"
              variant={variant}
              font
              style={{
                textTransform: "none",
              }}
            >
              {attr_title || post_title}
            </Link>
          ))}
        </Flex>
      </Section>
    </ThemedPageWrapper>
  );
};

export default Sitemap;
